<template>
    <div class="ele_price_wrap">
        <div class="search-wrap">
            <el-form
                :model="model"
                class="leader-style-form"
                label-width="100px"
                :inline="true"
                style="text-align: right"
            >
                <el-button type="primary" @click="saveElecPrice()">保存</el-button>
                <el-button type="primary" @click="addNew">新增</el-button>
            </el-form>
        </div>
        <div class="table-wrap-inner">
            <!-- <el-scrollbar style="height:100%"> -->
            <el-form style="height: 100%;" :model="ElecPriceForm" ref="ElecPriceFormRef" :rules="ElecPriceForm.rules">
                <el-table height="90%" border :data="ElecPriceForm.elecPrices" class="leader-style-table">
                    <el-table-column width="50" align="center" label="序号">
                        <template slot-scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="开始时间">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="'elecPrices.' + scope.$index + '.valid_start'"
                                :rules="ElecPriceForm.rules.valid_start"
                                :show-message="false"
                            >
                                <el-date-picker
                                    v-model="scope.row.valid_start"
                                    type="date"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="width: 90%"
                                ></el-date-picker>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="结束时间">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="'elecPrices.' + scope.$index + '.valid_end'"
                                :rules="ElecPriceForm.rules.valid_end"
                                :show-message="false"
                            >
                                <el-date-picker
                                    v-model="scope.row.valid_end"
                                    type="date"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="width: 90%"
                                ></el-date-picker>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="尖电价(元/度)">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="'elecPrices.' + scope.$index + '.sharp_price'"
                                :rules="ElecPriceForm.rules.sharp_price"
                                :show-message="false"
                            >
                                <el-input
                                    style="width:90%"
                                    v-model="scope.row.sharp_price"
                                    maxlength="12"
                                    v-Int.float
                                ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="峰电价(元/度)">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="'elecPrices.' + scope.$index + '.peak_price'"
                                :rules="ElecPriceForm.rules.peak_price"
                                :show-message="false"
                            >
                                <el-input
                                    style="width:90%"
                                    v-model="scope.row.peak_price"
                                    maxlength="12"
                                    v-Int.float
                                ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="谷电价(元/度)">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="'elecPrices.' + scope.$index + '.shoulder_price'"
                                :rules="ElecPriceForm.rules.shoulder_price"
                                :show-message="false"
                            >
                                <el-input
                                    style="width:90%"
                                    v-model="scope.row.shoulder_price"
                                    maxlength="12"
                                    v-Int.float
                                ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="平电价(元/度)">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="'elecPrices.' + scope.$index + '.off_price'"
                                :rules="ElecPriceForm.rules.off_price"
                                :show-message="false"
                            >
                                <el-input
                                    style="width:90%"
                                    v-model="scope.row.off_price"
                                    maxlength="12"
                                    v-Int.float
                                ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="固定电价(元)">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="'elecPrices.' + scope.$index + '.sum_price'"
                                :rules="ElecPriceForm.rules.sum_price"
                                :show-message="false"
                            >
                                <el-input
                                    style="width:90%"
                                    v-model="scope.row.sum_price"
                                    maxlength="12"
                                    v-Int.float
                                ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="光伏电价(元)">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="'elecPrices.' + scope.$index + '.gf_price'"
                                :rules="ElecPriceForm.rules.gf_price"
                                :show-message="false"
                            >
                                <el-input
                                    style="width:90%"
                                    v-model="scope.row.gf_price"
                                    maxlength="12"
                                    v-Int.float
                                ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="150">
                        <template slot-scope="scope">
                            <el-button
                                @click="delElecInfo(scope.row)"
                                type="text"
                                class="leader-button"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <div slot="footer" style="margin-top: 20px">
                        <el-button type="primary" class="btn-class" @click="saveElecPrice()">保存</el-button>
                </div>-->
            </el-form>
            <!-- </el-scrollbar> -->
        </div>
        <!-- 添加 -->
    </div>
</template>
<script>
import * as api from "@/http/api.js";
export default {
    components: {

    },
    data() {
        return {
            model: {
                target_unit_name: "",
                show_month: ""
            },
            tableData: [],
            pageNum: 1,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            totalPage: 0,
            selectPoint: {},
            ElecPriceForm: {
                rules: {
                    valid_start: {
                        required: true,
                        message: "请选择开始日期",
                        trigger: "change"
                    },
                    valid_end: {
                        required: true,
                        message: "请选择结束日期",
                        trigger: "change"
                    },
                    sharp_price: {
                        required: true,
                        message: "请输入尖电价",
                        trigger: "blur"
                    },
                    peak_price: {
                        required: true,
                        message: "请输入峰电价",
                        trigger: "blur"
                    },
                    shoulder_price: {
                        required: true,
                        message: "请输入谷电价",
                        trigger: "blur"
                    },
                    off_price: {
                        required: true,
                        message: "请输入平电价",
                        trigger: "blur"
                    },
                    sum_price: {
                        required: true,
                        message: "请输入固定电价",
                        trigger: "blur"
                    },
                    gf_price: {
                        required: true,
                        message: "请输入光伏电价",
                        trigger: "blur"
                    }
                },
                elecPrices: [
                    {
                        valid_start: "",
                        valid_end: "",
                        sharp_price: "",
                        peak_price: "",
                        shoulder_price: "",
                        off_price: "",
                        sum_price: "",
                        gf_price: "",
                    }
                ]
            },
        };
    },
    created() {
        this.getElectricChargePriceList();
    },
    methods: {
        getElectricChargePriceList() {
            api.getElectricChargePriceList().then(res => {
                if (res) {
                    this.ElecPriceForm.elecPrices = res.bus_json;
                }
            });
        },
        addNew() {
            const row = {
                valid_start: "",
                valid_end: "",
                sharp_price: "",
                peak_price: "",
                shoulder_price: "",
                off_price: "",
                sum_price: "",
                gf_price: "",
            };
            this.ElecPriceForm.elecPrices.push(row);
        },
        /*  * 删除电价
         */
        delElecInfo(sth) {
            this.$confirm("确认删除这条数据吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                this.ElecPriceForm.elecPrices.forEach(function (
                    item,
                    index,
                    arr
                ) {
                    if (item == sth) {
                        arr.splice(index, 1);
                    }
                });
            });
        },
        /**
         * 保存电价
         * */
        saveElecPrice(str) {
            this.$refs["ElecPriceFormRef"].validate((valid, model) => {
                if (valid) {
                    api.updateElectricChargePriceList(this.ElecPriceForm.elecPrices).then(res => {
                        if (res && res.error_code == "0") {
                            this.$message({
                                message: res.error_msg,
                                type: "success"
                            });
                            this.getElectricChargePriceList();
                        }
                    });
                }
            });
        },
    }
};
</script>
<style lang="scss">
.ele_price_wrap {
    padding: 0 20px;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    .el-form-item {
        margin: 5px 0;
    }
    .el-input__inner {
        background-color: transparent;
        color: #fff;
    }
    .search-wrap {
        text-align: right;
        margin-bottom: 20px;
    }
}
</style>
